"use client"
import { Heart } from "lucide-react"

export function FooterClient({
  weddingDate,
  weddingYear,
  corPrimaria,
  corSecundaria,
  nomeNoiva,
  nomeNoivo,
}: {
  weddingDate: string
  weddingYear: number
  corPrimaria: string
  corSecundaria: string
  nomeNoiva: string
  nomeNoivo: string
}) {
  return (
    <footer className="border-t py-6 md:py-0">
      <div className="container flex flex-col items-center justify-between gap-4 md:h-16 md:flex-row">
        <p className="text-center text-sm leading-loose text-muted-foreground md:text-left">
          &copy; {weddingYear} {nomeNoiva} & {nomeNoivo} • {weddingDate} • Todos os direitos reservados.
        </p>
        <p className="text-center text-sm text-muted-foreground flex items-center gap-1">
          Feito com <Heart className="h-4 w-4" style={{ color: corPrimaria }} /> para o nosso grande dia
        </p>
      </div>
    </footer>
  )
}

export default FooterClient
